import { useMemo } from 'react'
import { useDebounce } from '../../../../shared/hooks/useDebounce'
import { useArbeitszeitReportQuery } from '../../../../entities/arbeitszeit-report'
import {
  mapArbeitszeitFiltersFormToApi,
  ArbeitszeitReportFiltersForm,
} from './arbeitszeitReportFilters.types'
import {
  toArbeitszeitReportFiltersForm,
  useArbeitszeitReportFiltersParams,
} from './useArbeitszeitReportFiltersParams'

export function useArbeitszeitReportFilters() {
  const [params, setParams] = useArbeitszeitReportFiltersParams()

  const filters = useMemo<ArbeitszeitReportFiltersForm>(
    () => toArbeitszeitReportFiltersForm(params),
    [params],
  )

  const debouncedFilters = useDebounce(filters, 400)

  const apiFilters = useMemo(
    () =>
      mapArbeitszeitFiltersFormToApi(debouncedFilters, {
        pageAuftraege: params.pageAuftraege,
        pageAuslastung: params.pageAuslastung,
        pageArbeitsorganisation: params.pageArbeitsorganisation,
      }),
    [debouncedFilters, params.pageAuftraege, params.pageAuslastung, params.pageArbeitsorganisation],
  )

  const query = useArbeitszeitReportQuery(apiFilters)

  return {
    filters,
    setFilters: setParams,
    pageAuftraege: params.pageAuftraege,
    setPageAuftraege: (p: number) => setParams({ pageAuftraege: p }),
    pageAuslastung: params.pageAuslastung,
    setPageAuslastung: (p: number) => setParams({ pageAuslastung: p }),
    pageArbeitsorganisation: params.pageArbeitsorganisation,
    setPageArbeitsorganisation: (p: number) => setParams({ pageArbeitsorganisation: p }),
    ...query,
  }
}
